
export const domPackage = [{
    place : "Kashmir",
    link : "/packages/domestic"
  },
  {
    place : "Varanasi",
    link : "/packages/domestic"
  },
  {
    place : "Arupadi Vedu",
    link : "/packages/domestic"
  },
  {
    place : "Kerela",
    link : "/packages/domestic"
  },
  {
    place : "Darjeeling",
    link : "/packages/domestic"
  },
  {
    place : "Leh And Ladakh",
    link : "/packages/domestic"
  },
  {
    place : "Shimla & Manali",
    link : "/packages/domestic"
  },
  {
    place : "Guwahati",
    link : "/packages/domestic"
  },
  {
    place : "Char Dham Yatra",
    link : "/packages/domestic"
  },
 ]

  export const intPackage = [{
    place : "Bali",
    link : "/packages/international"
  },
  {
    place : "Singapore",
    link : "/packages/international"
  },
  {
    place : "Sri Lanka",
    link : "/packages/international"
  },
  {
    place : "Bhutan",
    link : "/packages/international"
  },
  {
    place : "Dubai",
    link : "/packages/international"
  },
  {
    place : "Malaysia",
    link : "/packages/international"
  },
  {
    place : "Nepal",
    link : "/packages/international"
  },
  {
    place : "Vietnam",
    link : "/packages/international"
  },
]